import React, { useState } from "react";
import Axios from "axios";
import { toast } from "react-toastify";
import { MdAddAPhoto } from "react-icons/md";
import { baseURL } from "../../configs/axiosConfig";

function ImageUploadS3({ refreshFunction, signupForm }) {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [imagePreview, setImagePreview] = useState("");
  const [avatar, setAvatar] = useState(null);

  const uploadS3Image = async (file) => {
    if (
      !file ||
      !["image/jpeg", "image/jpg", "image/png"].includes(file.type)
    ) {
      return toast.error("Invalid image format. Only jpg, jpeg, png allowed.");
    }

    const formData = new FormData();
    formData.append("file", file);

    setIsUploading(true);
    setUploadProgress(0);

    try {
      const xhr = new XMLHttpRequest();

      xhr.open("POST", `${baseURL}/api/products/uploadImageS3`, true);

      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          const percentComplete = Math.round(
            (event.loaded / event.total) * 100
          );
          setUploadProgress(percentComplete);
        }
      });

      // Handle success
      xhr.onload = async () => {
        setIsUploading(false);
        if (xhr.status === 200) {
          const res = JSON.parse(xhr.responseText);
          if (res.success) {
            setImagePreview(res.location); // Preview image URL from S3 response
            setAvatar(file);
            refreshFunction && refreshFunction(res.location);
            signupForm?.setFieldValue("photo", res.location);
            toast.success("Image uploaded successfully");
          } else {
            toast.error("Failed to upload image");
          }
        } else {
          toast.error("Failed to upload image");
        }
      };

      // Handle error
      xhr.onerror = () => {
        toast.error("Failed to upload image");
        setIsUploading(false);
      };

      // Send request
      xhr.send(formData);
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Something went wrong");
      setIsUploading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setAvatar(file);
    uploadS3Image(file);
  };

  return (
    <div className="flex flex-col gap-3 w-full max-w-sm">
      {/* Avatar Preview & Upload Button */}
      <div className="flex items-center gap-4">
        {imagePreview ? (
          <img
            src={imagePreview}
            alt="avatar"
            className="h-16 w-16 rounded-full object-cover shadow-md"
          />
        ) : (
          <div className="h-16 w-16 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-2xl shadow-inner">
            <MdAddAPhoto />
          </div>
        )}

        <label className="cursor-pointer px-4 py-2 bg-yellow-700 text-white rounded-md hover:bg-yellow-800 transition duration-300 ease-in-out">
          <span>Upload Avatar</span>
          <input
            type="file"
            name="photo"
            accept="image/jpeg,image/jpg,image/png"
            onChange={handleFileChange}
            className="hidden"
          />
        </label>
      </div>

      {/* Upload Progress Bar */}
      {isUploading && (
        <div className="w-full bg-gray-300 h-2 rounded-md overflow-hidden">
          <div
            className="h-full bg-yellow-700 transition-all"
            style={{ width: `${uploadProgress}%` }}
          />
        </div>
      )}
    </div>
  );
}

export default ImageUploadS3;
